/* eslint-disable import/no-cycle */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import style from './contact.module.scss';
import '../../../constants/_global.scss';
import Button from '../../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../../UI/button/buttonTypes';
import { useSelector } from '../../..';

interface ContactInterface {
  number: string;
  extraClass?: any;
  isOwner: boolean;
  isLogin: boolean;
  toLogin: () => void;
  toEdit: () => void;
  toDelete: () => void;
}

const Contact: React.FC<ContactInterface> = ({
  number,
  extraClass,
  isOwner,
  isLogin,
  toLogin,
  toEdit,
  toDelete,
}) => {
  const [showingNumber, setShowingNumber] = useState<boolean>(false);
  const isAdmin = useSelector((state) => state.userData.user.admin);
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 800 }),
  };

  const shellStyle = resolution.DesktopOrLaptop
    ? style.shell
    : style.shellMobile;
  const width = (number: number) =>
    !resolution.DesktopOrLaptop ? 800 : number;
  const tel = showingNumber ? number : `${number.slice(0, 4)}***`;

  return (
    <div>
      {!isLogin ? (
        <Button
          onClick={toLogin}
          disabled={false}
          ver={BUTTON_VER.primary}
          text="Авторизуйтесь, чтобы посмотреть контакт"
          customWidth={width(394)}
          type={BUTTON_TYPE.Button}
          extraClass={extraClass}
        />
      ) : null}
      {(isOwner && isLogin) || isAdmin ? (
        <div className={`${shellStyle} ${extraClass}`}>
          <Button
            onClick={toEdit}
            disabled={false}
            ver={BUTTON_VER.secondary}
            text="Редактировать объявление"
            customWidth={width(277)}
            type={BUTTON_TYPE.Button}
          />
          <Button
            onClick={toDelete}
            disabled={showingNumber}
            ver={BUTTON_VER.secondary}
            text="Удалить"
            customWidth={width(127)}
            type={BUTTON_TYPE.Button}
          />
        </div>
      ) : null}
      {!isOwner && isLogin ? (
        <div className={`${shellStyle} ${extraClass}`}>
          <Button
            onClick={() => setShowingNumber(true)}
            disabled={showingNumber}
            ver={BUTTON_VER.secondary}
            text="Показать контакты продавца"
            customWidth={width(289)}
            type={BUTTON_TYPE.Button}
          />
          <h2 className={`h2 ${style.h2}`}>{tel}</h2>
        </div>
      ) : null}
    </div>
  );
};

export default Contact;
